"use client";
import { loadStripe } from "@stripe/stripe-js";
import type { Stripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";

import { publicEnv } from "../../public-env";

export function useStripeClient(): Stripe | null {
  const [stripe, setStripe] = useState<Stripe | null>(null);

  useEffect(() => {
    const publishableKey = publicEnv?.PUBLIC_STRIPE_PUBLISHABLE_KEY;
    if (publishableKey == null) return;
    loadStripe(publishableKey).then((stripe) => stripe && setStripe(stripe));
  }, []);

  return stripe;
}

export const STRIPE_ELEMENTS_APPEARANCE = {
  theme: "stripe",
  variables: {
    colorPrimary: "#D5CB9F",
    colorText: "#332f21",
  },
  automatic_payment_methods: {
    enabled: true,
  },
} as const;
